import React from 'react';
import { Box } from '@mui/material';
import WorkspaceEmptyState from '../../../../shared/ui/workflow/WorkspaceEmptyState';

const MappingEmptyState: React.FC = () => (
  <Box
    role="status"
    aria-live="polite"
    sx={{
      height: '100%',
      minHeight: 0,
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <WorkspaceEmptyState
      tone="accent"
      dataTestId="mapping-empty-state"
      title="Select a mapping scope or shared export section"
      description="The navigator separates object type-owned PCF mappings from shared Revit sources and export settings. Select one to edit its downstream output."
      steps={[
        'Choose ALL or a specific object type to map PCF targets to Revit parameters, BOM columns, direct values, or formulas.',
        'Open a shared section to choose Revit sources for general attributes, process conditions, project properties, or statuses.',
        'Apply the mapping to update the active Revit project, or save and close when the workspace is ready.',
      ]}
    />
  </Box>
);

export default MappingEmptyState;
